"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionStorage = exports.localStorage = void 0;
var localstorage_1 = require("./localstorage");
var ENV = typeof window !== 'undefined' ? window : (typeof global !== 'undefined' ? global : undefined);
var ls = new localstorage_1.LocalStorage(ENV, localStorage);
exports.localStorage = ls;
var ss = new localstorage_1.LocalStorage(ENV, sessionStorage);
exports.sessionStorage = ss;
if (process.env.NODE_ENV !== 'production') {
    if (!ls.supported) {
        console.warn("You environment doesn't support LocalStorage");
    }
    if (!ss.supported) {
        console.warn("You environment doesn't support SessionStorage");
    }
}
__exportStar(require("./localstorage"), exports);
__exportStar(require("./env"), exports);
exports.default = ls;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUE2QztBQUU3QyxJQUFNLEdBQUcsR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FDbkQsT0FBTyxNQUFNLEtBQUssV0FBVyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FDN0IsQ0FBQTtBQUV2QixJQUFNLEVBQUUsR0FBRyxJQUFJLDJCQUFZLENBQUMsR0FBRyxFQUFFLFlBQVksQ0FBQyxDQUFBO0FBZ0J0QywwQkFBWTtBQWZwQixJQUFNLEVBQUUsR0FBRyxJQUFJLDJCQUFZLENBQUMsR0FBRyxFQUFFLGNBQWMsQ0FBQyxDQUFBO0FBZ0J4Qyw0QkFBYztBQWR0QixJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLFlBQVksRUFBRTtJQUN6QyxJQUFJLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRTtRQUNqQixPQUFPLENBQUMsSUFBSSxDQUFDLDhDQUE4QyxDQUFDLENBQUE7S0FDN0Q7SUFDRCxJQUFJLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRTtRQUNqQixPQUFPLENBQUMsSUFBSSxDQUFDLGdEQUFnRCxDQUFDLENBQUE7S0FDL0Q7Q0FDRjtBQUVELGlEQUE4QjtBQUM5Qix3Q0FBcUI7QUFPckIsa0JBQWUsRUFBRSxDQUFBIn0=